import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import { tablet768 } from '@nubank/nuds-web/styles/breakpoints';

import PersonProspectRegistrationForm from 'patterns/PersonProspectRegistrationForm/PersonProspectRegistrationForm';

export const StyledPersonProspectRegistrationForm = styled(PersonProspectRegistrationForm)`
  position: relative;
  background-color: ${nuDSColor('white')};
  border-radius: 1rem 1rem 0 0;
  height: 100%;

  ${tablet768`
    border-radius: 1rem;
  `};
`;

StyledPersonProspectRegistrationForm.displayName = 'StyledPersonProspectRegistrationForm';
